
import { Component, inject, Input } from '@angular/core';
import { NavigationEnd, RouterModule } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { UserTokens } from '../../../../services/user.service';
import { EzTextService } from "@template-ui/services/ez-text.service";
import { AppRoutingBaseComponent } from "@app/shared/components/app-routing-base.component";
import { BreadcrumbItem, buildBreadcrumbItems } from './breadcrumb-items';
import { PageIdentityService } from '@app/shared/services/page-identity.service';
export { BreadcrumbItem } from './breadcrumb-items';
@Component({
    selector: 'app-breadcrumb',
    imports: [RouterModule],
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent extends AppRoutingBaseComponent {

  templateService = inject(EzTextService);
  private readonly pageIdentity = inject(PageIdentityService);
  get visibleCrumbs(): BreadcrumbItem[] {
    const identity = this.pageIdentity.identity();
    return identity && identity.path === this.router.url.split('?')[0]
      ? [{ label: 'PHMS', url: '/' }, { label: identity.label, url: identity.path }]
      : this.crumbs;
  }

  /**
   * The list of breadcrumb items to display.
   */
  @Input() crumbs: BreadcrumbItem[] = [];
  constructor(

  ) {
    super();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        map(() => buildBreadcrumbItems(this.activatedRoute.root, (label, params) => this.resolvedLabel(label, params))),
      ).pipe(this.takeUntilDestroyed())
      .subscribe((breadcrumbs) => {
        this.crumbs = breadcrumbs;
      });
  }

  // Resolve Tokens
  private resolvedLabel(label: string, snapshotParams: any): string {

    const rtn = this.templateService.resolveTemplate(label, snapshotParams);

    return rtn
      .replace(UserTokens.TOKEN_FIRST_NAME, this.userService.firstName || '')
      .replace(UserTokens.TOKEN_LAST_NAME, this.userService.lastName || '')
  }
}
